/**
 * AddButton Handler для HeaderPage
 * 
 * Додає кнопку "Додати" в HeaderPage для створення нового запису CRUD ресурсу
 * Кнопка викликає action create для відкриття форми створення
 */

import React from 'react'
import { AiOutlineAppstoreAdd } from 'react-icons/ai'
import type { IHeaderPageButtonHandlerParams } from '../../types'

/**
 * Додає кнопку "Додати" в HeaderPage (для CRUD ресурсів)
 * 
 * @param params - параметри з buttons та crudContext
 */
export const AddButton = ({ buttons, crudContext }: IHeaderPageButtonHandlerParams) => { 
    buttons['AddButton'] = {
        label: crudContext?.settings?.['addButtonLabel'] ?? crudContext?.resource?.settings?.['addButtonLabel'] ?? 'Додати',
        icon: React.createElement(AiOutlineAppstoreAdd, { style: { fontSize: 24 } }),
        sort: 100,
        priority: 'button',
        size: 'middle',
        type: 'primary',
        depFn: ({ crudContext }: any) =>
            crudContext && 
            crudContext.actions && 
            typeof crudContext.actions.create === 'function' &&
            crudContext.accessFn && 
            typeof crudContext.accessFn === 'function'
                ? crudContext.accessFn({
                        accessMode: 'create',
                        crudContext: crudContext,
                }) === true
                : false,
        style: { display: 'flex', alignItems: 'center', position: 'relative' },
        onClick: () => {
            if (crudContext?.actions?.create) {
                crudContext.actions.create(crudContext.storages?.addButton?.initialValues ?? {})
            }
        },
    }
}
